import React, { useEffect, useRef, useState } from 'react'
import * as d3 from 'd3'
import Circle from './Circle' // Import the Circle component
import { useDispatch, useSelector } from 'react-redux'
import {
    setCurrentClinic,
    setCurrentClinicExcerpt,
    setCurrentClinicLocation,
    setCurrentClinicThumbnail,
    setCurrentClinicTitle,
} from '../store'
$ = jQuery

// const locations = [
//     { coords: [50.1953534961647, 10.072319368105768], info: 'Clinic 1' },
//     { coords: [50.187305925217956, 10.070522810433642], info: 'Clinic 2' },
//     { coords: [50.19816459383602, 10.071817725777569], info: 'Clinic 3' },
//     { coords: [50.19734856808119, 10.071928254613326], info: 'Clinic 4' },
//     { coords: [52.51803235982062, 13.569380912418119], info: 'Clinic 5' },
//     { coords: [49.542388760106824, 10.235457139233342], info: 'Clinic 6' },
//     { coords: [49.37373768726715, 12.706427023880734], info: 'Clinic 7' },
//     { coords: [48.00576380451981, 10.58854293914881], info: 'Clinic 8' },
// ]

// console.log('current_clinic:', current_clinic)

const GermanyMap = () => {
    const dispatch = useDispatch()
    const svgRef = useRef(null)
    const [projection, setProjection] = useState(null)
    // const [currentLocation, setCurrentLocation] = useState(
    //     $('#clinic_location_map').data('location')
    // )
    // const [currentClinic, setCurrentClinic] = useState(current_clinic)

    const { currentClinic, clinics } = useSelector((state) => state.clinics)

    const [isDragging, setIsDragging] = useState(false)

    useEffect(() => {
        const svg = d3.select(svgRef.current)
        const width = 400
        const height = 600

        d3.json(
            'https://raw.githubusercontent.com/isellsoap/deutschlandGeoJSON/main/1_deutschland/1_sehr_hoch.geo.json'
        ).then((germany) => {
            const projection = d3
                .geoMercator()
                .fitSize([width, height], germany)
            setProjection(() => projection)
            const path = d3.geoPath().projection(projection)

            svg.select('g.map-layer')
                .selectAll('path')
                .data(germany.features)
                .enter()
                .append('path')
                .attr('d', path)
                .attr('fill', '#EDEBE2')
                .attr('stroke', '#9D8A7E')
                .attr('stroke-width', 1.5)
        })
    }, [])

    const handleMapClick = (event) => {
        if (projection) {
            const [x, y] = d3.pointer(event)
            const [longitude, latitude] = projection.invert([x, y])
            dispatch(setCurrentClinicLocation([latitude, longitude]))
        }
    }

    const handleMouseDown = (event) => {
        setIsDragging(true)
    }

    const handleMouseMove = (event) => {
        if (!isDragging) return
        const [x, y] = d3.pointer(event)
        const [longitude, latitude] = projection.invert([x, y])
        dispatch(setCurrentClinicLocation([latitude, longitude]))
    }

    const handleMouseUp = () => {
        setIsDragging(false)
    }

    useEffect(() => {
        if (
            !currentClinic ||
            !currentClinic.location ||
            !Array.isArray(currentClinic.location) ||
            currentClinic.location.length !== 2 ||
            !$('#clinic_location_input')
        )
            return
        $('#clinic_location_input').val(JSON.stringify(currentClinic.location))
    }, [currentClinic])

    useEffect(() => {
        // if we are in the admin panel
        if (window.location.href.indexOf('wp-admin') === -1) return
        $('#title').on('input', function () {
            // Change 'change' to 'input'
            dispatch(setCurrentClinicTitle($(this).val()))
        })

        $('#excerpt').on('input', function () {
            // Change 'change' to 'input'
            dispatch(setCurrentClinicExcerpt($(this).val()))
        })

        // every 100ms
        const interval = setInterval(() => {
            console.log($('#_thumbnail_id').val())
            if (
                $('#_thumbnail_id').val() != '-1' &&
                $('#postimagediv .inside img') &&
                $('#postimagediv .inside img').attr('src')
            ) {
                dispatch(
                    setCurrentClinicThumbnail(
                        $('#postimagediv .inside img').attr('src')
                    )
                )
            }
        }, 500)
        // Cleanup function to remove event listeners
        return () => {
            $('#title').off('input')
            $('#excerpt').off('input')
            $('#_thumbnail_id').off('input')
            $('#_thumbnail_id').off('change')
            clearInterval(interval)
        }
    }, [])

    return (
        <svg
            ref={svgRef}
            width='450'
            height='600'
            onClick={handleMapClick}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
        >
            <g className='map-layer' />
            <g className='circle-layer'>
                {projection && (
                    <>
                        {clinics.map((clinic, index) => (
                            <Circle
                                key={index}
                                coordinates={clinic.location}
                                projection={projection}
                                info={clinic}
                            />
                        ))}
                        {currentClinic && (
                            <Circle
                                coordinates={currentClinic.location}
                                projection={projection}
                                red
                                info={currentClinic}
                                onMouseDown={handleMouseDown} // Pass the mouse down event handler
                            />
                        )}
                    </>
                )}
            </g>
        </svg>
    )
}

export default GermanyMap
